import $ from "jquery";
import "parsleyjs";
import { isFunction } from "@/scripts/helpers/is";
import { disableElement } from "@/scripts/helpers/elementsActions";
import { STRINGS } from "@/scripts/helpers/constants";

export const attachJQueryPlugins = function() {
  if ($) {
    $.fn.inView = function() {
      const win = $(window);
      const obj = $(this);
      const scrollPosition = win.scrollTop();
      const visibleArea = win.scrollTop() + win.height();
      const objEndPos = obj.offset().top;

      return visibleArea >= objEndPos && scrollPosition <= objEndPos;
    };
  }
};

export const bindJQuery = function() {
  window.$ = window.JQuery = window.jQuery = $;

  attachJQueryPlugins();
};

export const attachIE11helper = () => {
  if (navigator.userAgent.match(/Trident.*rv:11\./))
    $("body").addClass("is-ie11");
};

export const attachEdgeBrowserHelper = () => {
  if (/Edge/.test(navigator.userAgent)) $("body").addClass("is-edge");
};

export const attachFirefoxBrowser = () => {
  if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1)
    $("body").addClass("is-firefox");
};

export const attachSafariBrowser = () => {
  if (
    navigator.userAgent.search("Safari") >= 0 &&
    navigator.userAgent.search("Chrome") < 0
  )
    $("body").addClass("is-safari");
};

export const classes = {
  isActive: "is-active",
  loader: "loader",
  loaderWrapper: "loader-wrapper",
  formInput: ".form-control",
  formSubmit: ".form-submit",
  formInner: ".form__inner",
  successStatus: "status-action-success",
  failedStatus: "status-action-failed",
  ctaStyled: "call-to-action-styled"
};

// Forms functionality
const addParsleyFieldAttrs = form => {
  const email = form.find('input[type="email"]');
  // TODO cache strings to CONSTANTS
  if (email.length) {
    if (!email.data("parsleyType")) {
      email.attr("data-parsley-type", "email");
    }
    if (!email.data("parsleyRequiredMessage")) {
      email.attr(
        "data-parsley-required-message",
        STRINGS.EMAIL_ERROR_MESSAGE
      );
    }
  }
};

const hideErrorByEvent = event => {
  $(classes.formInput).on(event, function() {
    const input = $(this);
    input.parsley().reset();
  });
};

export const handleParsleyActions = selector => {
  // TODO discuss default input messages (to avoid adding field attrs in Pug)
  const forms = $("form");

  if (forms.length) {
    forms.each(function() {
      const form = $(this);

      form.attr("data-parsley-focus", "none");
      addParsleyFieldAttrs(form);

      form
        .parsley({
          requiredMessage: "This field is required"
        })
        .on("field:error", function() {
          const field = this.$element;
          const selectWrapperClass = ".selectric-wrapper";
          if (field.is("select")) {
            const selectWrapper = field.parents(selectWrapperClass);

            if (selectWrapper.length) selectWrapper.addClass("has-error");
          }
        });
    });
  }
  hideErrorByEvent("focus");
};

export const handleFormActions = (
  selector,
  successCallback,
  validateCustomInputs
) => {
  const form = $(selector);
  const formSubmit = form.find(classes.formSubmit);
  let customInputsValid = null;

  if (form.length) {
    form
      .parsley()
      .on("form:validate", function() {
        if (isFunction(validateCustomInputs))
          customInputsValid = validateCustomInputs.call();
      })
      .on("form:submit", function() {
        if (isFunction(validateCustomInputs) && !customInputsValid)
          return false;

        disableElement(formSubmit);

        if (isFunction(successCallback)) {
          successCallback.call();
          return false;
        }
      });
  }
};

export const resetForm = element => {
  // TODO create func restFormToState (form can be not always empty by default)
  if (element.length) {
    const inputs = element.find(classes.formInput);

    inputs.each(function() {
      $(this).val("");
    });
  }
};
